module.exports = __webpack_public_path__ + "img/a-bg2.4acaef65.png";